module.exports = __webpack_public_path__ + "img/media-donews.9d5a54c2.png";